import { render, staticRenderFns } from "./distributorTeam.vue?vue&type=template&id=be37a522&scoped=true&"
import script from "./distributorTeam.vue?vue&type=script&lang=js&"
export * from "./distributorTeam.vue?vue&type=script&lang=js&"
import style0 from "./distributorTeam.vue?vue&type=style&index=0&id=be37a522&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be37a522",
  null
  
)

export default component.exports